import React from 'react';
import { Col } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { useAuthState } from '@packages/contexts/auth';
import colors from '@packages/core/styles/colors';

const useFooterStyles = createUseStyles({
    footerContainer: {
        backgroundColor: colors.grayTwo,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '35px 60px 10px 60px',
        flexWrap: 'wrap',
    },
    row: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 24,
    },
    column: {
        height: 130,
        minWidth: 200,
        flex: '1 1 200px',
    },
    link: {
        fontSize: 15,
        fontWeight: '400',
        lineHeight: '20px',
    },
    compactList: {
        marginTop: 0,
    },
    '@media (max-height: 800px)': {
        footerContainer: {
            padding: '20px 32px 8px 32px',
        },
        row: {
            gap: 16,
        },
        column: {
            height: 'auto',
        },
        link: {
            fontSize: 13,
            lineHeight: '18px',
        },
        compactList: {
            marginTop: 12,
        },
    },
    '@media (max-width: 1024px)': {
        row: {
            flexWrap: 'wrap',
        },
        column: {
            height: 'auto',
        },
        compactList: {
            marginTop: 12,
        },
    },
});

export const Footer = () => {
    const classes = useFooterStyles();
    const { account } = useAuthState();
    const isAuthenticated = !!account;
    const pathPrefix = isAuthenticated ? '/app' : '/public';

    const links = {
        siteLinks: [
            { label: 'Privacy Policy', href: `${pathPrefix}/privacy-policy` },
            { label: 'Terms & Conditions', href: `${pathPrefix}/terms-conditions` },
            { label: 'FAQ', href: `${pathPrefix}/faq` },
            { label: 'Contact Us', href: `${pathPrefix}/contact_us` },
        ],
        otherSites: [
            { label: 'ASE', href: 'https://www.ase.com/' },
            { label: 'Special Service Tools', href: 'https://subaru.service-solutions.com/' },
            { label: 'Kenwood', href: 'https://store.kenwoodusa.com/catalog.php?cat_id=S19/' },
            { label: 'NASTF', href: 'https://www.nastf.org/' },
        ],
        other: [
            { label: 'Dealer Equipment and Services', href: 'https://subaruretailersolutions.com/equipment' },
            { label: 'SubaruDT', href: 'https://www.subarunet.com/home/' },
            { label: 'ASE Education Foundation', href: 'https://www.aseeducationfoundation.org/' },
            { label: 'subaru.com', href: 'https://www.subaru.com/' },
            { label: 'Diagnostic Tool Information', href: `${pathPrefix}/diagnostic-tool-info`, internal: true },
        ],
    };

    return (
        <div className={classes.footerContainer}>
            <div className={classes.row}>
                <Col className={classes.column}>
                    <h6>Site Links</h6>
                    <ul className="list-unstyled">
                        {links.siteLinks.map((link) => (
                            <li className={classes.link} key={link.label}>
                                <Link to={link.href}>{link.label}</Link>
                            </li>
                        ))}
                    </ul>
                </Col>

                <Col className={classes.column}>
                    <h6>Other Sites</h6>
                    <ul className="list-unstyled">
                        {links.otherSites.map((link) => (
                            <li className={classes.link} key={link.label}>
                                <a href={link.href} target="_blank" rel="noopener noreferrer">
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </Col>

                <Col className={classes.column}>
                    <ul className={`list-unstyled ${classes.compactList}`}>
                        {links.other.map((link) => (
                            <li className={classes.link} key={link.label}>
                                {link.internal ? (
                                    <Link to={link.href}>{link.label}</Link>
                                ) : (
                                    <a href={link.href} target="_blank" rel="noopener noreferrer">
                                        {link.label}
                                    </a>
                                )}
                            </li>
                        ))}
                    </ul>
                </Col>
            </div>
        </div>
    );
};
